import _ from 'lodash'
import { GetterTree } from 'vuex'
import { Booth, BoothsState } from '@/store/booths/types'
import { RootState } from '@/store/types'
import { Campus, University } from '../master/types'

const getters : GetterTree<BoothsState, RootState> = {
  /**
   * ブース情報を取得
   * @param {University} university 大学
   * @param {Campus} campus キャンパス
   * @param {string} building 建物名
   * @param {string} room 部屋番号
   * @param {string} booth ブース番号
   */
  findBoothByNames: (state) => (
    {
      university, campus, building, room, number,
    }: {
      university: University,
      campus: Campus,
      building: string,
      room: string,
      number: string,
    },
  ): Booth|null => {
    return _.find(state.booths, {
      university,
      campus,
      building,
      room,
      number,
    }) as Booth|undefined || null
  },

  /**
   * ブースIDを元にブース情報を取得
   *
   * @param {string} boothId ブースID
   * @returns {Booth|null} ブース情報
   */
  findBoothById: (state) => (boothId: string): Booth|null => {
    return _.find(state.booths, { id: boothId }) || null
  },
}

export default getters
